<template>
  <div class="dialog"  ref="dialog">
    <div class="content">
      <div class="top">
        <div class="title">{{ title }}</div>
      </div>
      <div class="body">
        <slot></slot>
      </div>
      <div class="bottom">
        <button class="btn" @click="onCancel">Cancel</button>
        <button class="btn warning" @click="onConfirm">{{ confirmButtonText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from '@eds/vanilla';

export default {
  props: {
    title: {
      type: String,
      default: 'Leave without saving?'
    },
    confirmButtonText: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      dialog: Dialog,
      confirmationData: undefined
    };
  },

  mounted() {
    this.dialog = new Dialog(this.$refs.dialog);
  },

  methods: {
    hide() {
      this.dialog.hide();
    },

    show(confirmationData) {
      this.confirmationData = confirmationData;
      this.dialog.show();
    },
    
    onCancel() {
      this.$emit('canceled');
    },

    onConfirm() {
      this.$emit('confirmed', this.confirmationData);
    }
  }
}
</script>